<template>
    <div class="w-100 h-100 d-flex flex-column justify-content-center align-items-start">
        <form :action="searchAction"
              method="GET"
              class="search__container"
              role="search"
        >
            <h1 class="search__title fs-h1-xlarge">
                <label for="search-input">{{ searchLabel }}</label>
            </h1>
            <div class="simple-input-group secondary-text">
                <input id="search-input"
                       ref="searchInput"
                       name="q"
                       type="text"
                       class="simple-input"
                       :aria-label="searchText"
                >
                <button class="btn__icon"
                        type="submit"
                        :aria-label="searchLabel"
                >
                    <i class="icon-arrow" aria-hidden="true"></i>
                </button>
            </div>
        </form>
    </div>
</template>

<script>
    import getSearchLabel from './search-label';
    import { isOnDanish } from '../utils/is-on-language';

    export default {
        data () {
            return {
                searchAction: isOnDanish() ? '/search' : '/english/search',
                searchText: isOnDanish() ? 'søgeord' : 'search text',
                searchLabel: getSearchLabel(),
            };
        },
        mounted () {
            this.$refs.searchInput.focus();
        },
    };
</script>
